import { render, staticRenderFns } from "./StatusesBox.vue?vue&type=template&id=0565a4d8"
import script from "./StatusesBox.vue?vue&type=script&lang=js"
export * from "./StatusesBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports